import { schema } from 'normalizr'

import group from './group-schema'

const image = new schema.Entity('image')
const cheer = new schema.Entity('cheers')
const answer = new schema.Entity('answers')
const groupMember = new schema.Entity('groupMember')
const meta = new schema.Entity('meta')

const user = new schema.Entity(
    'user',
    { image },
    { processStrategy: entity =>
        Object.assign({}, entity, {
            image: entity.image ? entity.image.data : null,
            avatar: entity.image ? entity.image.data.path : null,
        }) }
)

const invitation = new schema.Entity(
    'invitations',
    {
        user,
        sender: user,
        groupMember,
    },
    { processStrategy: entity =>
        Object.assign({}, entity, {
            user: entity.user ? entity.user.data : null,
            groupMember: entity.groupMember ? entity.groupMember.data : null,
            sender: entity.sender ? entity.sender.data : null,
            group: entity.groupMember && entity.groupMember.data && entity.groupMember.data.group ? entity.groupMember.data.group.data : null,
        }) }
)

const attendance = new schema.Entity(
    'attendance',
    {
        user,
        groupMember,
    },
    { processStrategy: entity =>
        Object.assign({}, entity, {
            user: entity.user ? entity.user.data : null,
            groupMember: entity.groupMember ? entity.groupMember.data : null,
            group: entity.groupMember && entity.groupMember.data && entity.groupMember.data.group ? entity.groupMember.data.group.data : null,
        }) }
)

const question = new schema.Entity(
    'questions',
    { answers: [answer] },
    { processStrategy: entity =>
        Object.assign({}, entity, { answers: entity.answers
            ? entity.answers.data.map(a => Object.assign({}, a, { response: JSON.parse(a.response) }))
            : [] }) }
)

export const rosterPosition = new schema.Entity(
    'rosterPositions',
    { questions: [question] },
    { processStrategy: entity =>
        Object.assign({}, entity, { questions: entity.questions ? entity.questions.data : [] }) }
)

export default new schema.Entity(
    'events',
    {
        organisingGroup: group,
        owner: user,
        rosterPositions: [rosterPosition],
        cheers: [cheer],
        attendance: [attendance],
        invitations: [invitation],
        managers: [user],
        meta: [meta],
    },
    {
        idAttribute: 'slug',
        processStrategy: entity =>
            Object.assign({}, entity, {
                organisingGroup: entity.organisingGroup ? entity.organisingGroup.data : null,
                owner: entity.owner ? entity.owner.data : null,
                rosterPositions: entity.rosterPositions ? entity.rosterPositions.data : [],
                cheers: entity.cheers ? entity.cheers.data : [],
                managers: entity.managers ? entity.managers.data : [],
                attendance: entity.attendance ? entity.attendance.data : [],
                invitations: entity.invitations ? entity.invitations.data : [],
                meta: entity.meta ? entity.meta.data : [],
            }),
    }
)

/** @TODO learn to properly use normalizer or dont use it at all ... */
export const frontEventSchema = new schema.Entity(
    'events',
    {
        rosterPositions: [rosterPosition],
        cheers: [cheer],
        attendance: [attendance],
        invitations: [invitation],
    },
    {
        idAttribute: 'slug',
        processStrategy: entity =>
            Object.assign({}, entity, {
                rosterPositions: entity.rosterPositions ? entity.rosterPositions.data : [],
                cheers: entity.cheers ? entity.cheers.data : [],
                attendance: entity.attendance ? entity.attendance.data : [],
                invitations: entity.invitations ? entity.invitations.data : [],
            }),
    }
)
